// extracted by mini-css-extract-plugin
export default {"label":"SettingsSecurityDeleteAccountConfirmList_label__GnutV","list":"SettingsSecurityDeleteAccountConfirmList_list__H84+Y"};